import "../../../assets/scss/all-login.scss";
import { useNavigate } from "react-router-dom";
import axiosService from "../../../core/services/axios-service";
import ToastService from "../../../core/services/toaster-service";
import localStorageService from "../../../core/services/local-storage-service";
import { messageEnum } from "../../../core/dictionary/global-enums";
import { useState } from "react";

export default function AllLogin(props) {
  const { config } = props;
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axiosService.post(config.apiEndpoint, {
        email: form.email,
        password: form.password,
      });
      if (res.data.success) {
        const currentLoginType = props.config.loginType || "admin-login";
        // Save token if needed: localStorage.setItem("token", res.data.token);
        const responseData =
          currentLoginType === "coach-team-member-login"
            ? res.data.data
            : res.data;
        const currentRole =
          currentLoginType === "coach-team-member-login"
            ? responseData.user.role
            : responseData.role;
        localStorageService.setToken(responseData.token);
        localStorageService.setRole(currentRole);
        if (currentLoginType === "coach-team-member-login") {
          localStorageService.setUserDetails(responseData.user);
        }
        ToastService.success(messageEnum.adminLoginSuccessfull);
        // Redirect to dashboard or another page
        setTimeout(() => {
          navigate(config.nextNavigationPath);
        }, 1000);
      } else {
        setError(res.data.message || "Login failed");
        ToastService.error(res.data.message || "Login failed");
      }
    } catch (err) {
      setError("Invalid credentials or server error");
      ToastService.error("Invalid credentials or server error");
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      {/* Left side */}
      <div className="login-left">
        <img
          src="https://res.cloudinary.com/dhhzpdckr/image/upload/v1758128880/rescuernlogo_dsi3mf.png"
          alt="Rescuern Logo"
          className="company-logo"
        />
        <h1>{config.rightSectionHeading}</h1>
        <p>{config.rightSectionSubHeading}</p>
      </div>

      {/* Right side */}
      <div className="login-right">
        <div className="login-card">
          <h2>{config.leftCardHeading}</h2>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email</label>
              <input
                id="email"
                name="email"
                type="email"
                className="login-input"
                placeholder="name@example.com"
                autoComplete="email"
                required
                value={form.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                id="password"
                name="password"
                type="password"
                className="login-input"
                placeholder="Enter your password"
                autoComplete="current-password"
                required
                value={form.password}
                onChange={handleChange}
              />
            </div>

            {error && <div className="text-danger mb-2">{error}</div>}
            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
